<template>
  <form class="my-5 mx-5">
    <b-form-group id="language" :label="$t($getConst.pages.language.name)" label-for="language-input">
      <multiselect
        id="language-input"
        v-model="$v.language.$model"
        :class="{ 'is-invalid': $v.language.$error || languageExist}"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="languages"
        :disabled="languageToEdit?true:false"
      >
      </multiselect>
      <AppFormFeedback :errors="$v.language"/>
      <b-form-invalid-feedback v-if="languageExist">
        {{$t(this.$getConst.pages.form.exist_field_error)}}.
      </b-form-invalid-feedback>
    </b-form-group>
    <br>
    <div v-if="$v.language.code.$model">
      <label>{{$t($getConst.pages.language.code)}}</label>&emsp;&emsp; {{$v.language.code.$model}}
    </div>
    <br>
    <div v-if="$v.language.code.$model">
      <label>{{$t($getConst.pages.language.flags)}}</label>&emsp;&emsp;  <lang-flag :iso="$v.language.code.$model" :squared="false"/>
    </div>
    <br>
    <b-form-group id="nav-language-id" :label="$t($getConst.pages.language.nav_language_id)" label-for="nav-language-id-input">
      <b-form-input
        id="nav-language-id-input"
        v-model.trim="$v.nav_language_id.$model"
        :placeholder="$t(this.$getConst.pages.language.enter_nav_language_id)"
        :class="{ 'is-invalid': $v.nav_language_id.$error || language_nav_id_Exist}"
        size="lg"
        required
      ></b-form-input>
      <AppFormFeedback :errors="$v.nav_language_id"/>
      <b-form-invalid-feedback v-if="language_nav_id_Exist">
        {{$t(this.$getConst.pages.form.exist_field_error)}}.
      </b-form-invalid-feedback>
    </b-form-group>
  </form>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import {addLanguage, editLanguage} from "../../api/languages.api";
  import languages from "../../shared/constants/languages/languages";
  import AppFormFeedback from "../../components/common/form/AppFormFeedback";
  import LangFlag from 'vue-lang-code-flags';
  export default {
    name: "LanguageForm",
    components: {AppFormFeedback, LangFlag},
    data() {
      return {
        isLoading: false,
        languageExist: false,
        language_nav_id_Exist: false,
        action: 'add',
        languages: languages,
        language: {
          name: null,
          code: null,
        },
        nav_language_id: null,
        isSubmited: false
      }
    },
    props: {
      modal_id: null,
      languageToEdit: null,
    },
    validations: {
      language: {
        name: {required},
        code: {required},
      },
      nav_language_id: {required},
    },
    created() {
      if (this.languageToEdit) {
        this.action = 'edit';
        this.language=this.languageToEdit;
        this.nav_language_id = this.languageToEdit.nav_language_id;
      }
    },
    mounted() {
      this.$root.$on('isSubmited', submit => {
        this.isSubmited = submit;
      });
    },
    methods: {
      closeModal() {
        this.$bvModal.hide(this.modal_id)
      },
      addLanguage() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isSubmited = false;
          return;
        }
        this.$root.$emit('isLoading', true);
        this.languageExist = false;
        this.language_nav_id_Exist = false;
        let lang = {"name": this.language.name, "code": this.language.code, "nav_language_id": this.nav_language_id};
        addLanguage(lang).then(
          res => {
            this.$root.$emit('onAddLanguage', res.data);
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
            this.closeModal();
          },
          error => {
            if (error.response.data.code === 422) {
              this.languageExist = 'name' in error.response.data.error;
              this.language_nav_id_Exist = 'nav_language_id' in error.response.data.error;
            }
            this.handleApiError(error);
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
          }
        )
      },
      editLanguage() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isSubmited = false;
          return;
        }
        this.$root.$emit('isLoading', true);
        this.languageExist = false;
        let lang = {"name": this.language.name, "code": this.language.code, "nav_language_id": this.nav_language_id};
        editLanguage(this.languageToEdit.id,lang).then(
          res => {
            this.$root.$emit('onEditLanguage', res.data);
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
            this.closeModal();
          },
          error => {
            if (error.response.data.code === 422) {
              this.languageExist = true;
            }
            else if(error.response.data && error.response.data.includes('languages_nav_language_id_unique')){
              this.$snotify.error(this.$t(this.$getConst.pages.language.language_nav_exist));
            } else {
              this.$snotify.error(this.$t(this.$getConst.pages.alerts.unknown_error));
            }
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
          }
        )
      }
    },
    watch: {
      isSubmited: function() {
        if(this.isSubmited) {
          if (this.languageToEdit) {
            this.editLanguage();
          } else {
            this.addLanguage();
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
